import React, {useState, useEffect, useRef} from 'react';
import {findEnabledCustomersByQueryString} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";

const PdvCustomerPendingSaleList = () => {
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const data = await findEnabledCustomersByQueryString(query) || [];
            data.forEach(c => c.checked = false);
            setCustomers(data);
            setFilteredCustomers(data);
            setQueryString(query);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) inputQueryString.current.focus();
        makeQuery('');
    }, []);

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    useEffect(() => {
        const filtered = customers.filter(f => f.checked || removeSpecialChars(f.name).toUpperCase().includes(queryString));
        const sorted = getCustomersSortedByChecked(filtered);
        setFilteredCustomers(sorted);
        if (inputQueryString.current) inputQueryString.current.focus();
    }, [queryString]);

    const handleInputChange = (e) => {
        setQueryString(removeSpecialChars(e.target.value).toUpperCase());
    };

    const onCheckBoxChange = (index) => {
        const updated = [...filteredCustomers];
        updated[index].checked = !updated[index].checked;
        setFilteredCustomers(getCustomersSortedByChecked(updated));
        setQueryString('');
    };

    function getCustomersSortedByChecked(list) {
        return list.filter(c => c.checked).concat(list.filter(c => !c.checked));
    }

    function doConfirm() {
        const idsString = customers.filter(c => c.checked).map(c => c.id).join(',');
        navigate(`/pdv/finishitems/${idsString}`);
    }

    return (
        <>
            <div className="header-label">Fechar Comanda</div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                 className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={handleInputChange} onFocus={(e) => e.target.select()} inputMode="numeric"
                       onKeyDown={(e) => e.key === 'Enter' && doConfirm()}/>
                <button id="clearButton" onClick={() => { setQueryString(''); inputQueryString.current.focus(); }}>X</button>
            </div>
            <div style={{flexGrow: 1, overflowY: 'auto'}}>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '10px'}}/>
                        <col style={{width: '300px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <tbody>
                    {filteredCustomers.map((customer, index) => (
                        <tr key={index} style={{backgroundColor: customer.checked ? 'var(--warning-color)' : 'white'}}>
                            <td>
                                <input type="checkbox" checked={customer.checked} onChange={() => onCheckBoxChange(index)}/>
                            </td>
                            <td><div>{customer.name}</div></td>
                            <td>
                                {filteredCustomers.filter(c => c.checked).length === 0 && (
                                    <button onClick={() => navigate('/pdv/finishitems/' + customer.id)}>Conferir</button>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {customers.length === 0 && <tfoot><tr><td colSpan={3}>Nenhum item encontrado</td></tr></tfoot>}
                </table>
            </div>
            {filteredCustomers.filter(c => c.checked).length > 0 && (
                <ActionButtonsManagerView>
                    <button onClick={doConfirm}>Conferir</button>
                </ActionButtonsManagerView>
            )}
        </>
    );
};

export default PdvCustomerPendingSaleList;
